import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["repoSlug", "projectId", "embedOpts", "openOpts", "files", "title", "description", "template", "tags", "dependencies", "settings"],
  _excluded2 = ["elementOrId"];
import React from 'react';
import sdk from "@stackblitz/sdk";
import { jsx as _jsx } from "react/jsx-runtime";
var stackBlitz = props => {
  var _ref = props || {},
    {
      repoSlug,
      projectId,
      embedOpts = {},
      openOpts,
      files,
      title,
      description,
      template = 'create-react-app',
      tags,
      dependencies,
      settings
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var {
      elementOrId
    } = embedOpts,
    otherEmbedOpts = _objectWithoutPropertiesLoose(embedOpts, _excluded2);
  function handleClick(event) {
    var project = {
      files,
      title,
      description,
      template,
      tags,
      dependencies,
      settings
    };
    if (elementOrId && projectId) {
      sdk.embedProjectId(elementOrId, projectId, project);
    } else if (projectId) {
      sdk.openProjectId(projectId, project);
    } else if (elementOrId && repoSlug) {
      sdk.embedGithubProject(elementOrId, repoSlug, project);
    } else if (repoSlug) {
      sdk.openGithubProject(repoSlug, project);
    } else if (elementOrId) {
      sdk.embedProject(elementOrId, project, otherEmbedOpts);
    } else {
      sdk.openProject(_extends({}, project), openOpts);
    }
    if (other.onClick) {
      other.onClick(event);
    }
  }
  return /*#__PURE__*/_jsx("button", _extends({
    type: "button"
  }, other, {
    onClick: handleClick,
    children: props.children
  }));
};
export default stackBlitz;